import { render, staticRenderFns } from "./ClientSelector.vue?vue&type=template&id=395ffc8a&"
import script from "./ClientSelector.vue?vue&type=script&lang=js&"
export * from "./ClientSelector.vue?vue&type=script&lang=js&"
import style0 from "./ClientSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClientSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports